import React from 'react';
import PropTypes from 'prop-types';
import { Typography, colors } from 'kangarootime-ui';
import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  switchBase: {
    '&$checked': {
      color: colors.brand_3
    },
    '&$checked + $track': {
      backgroundColor: colors.brand_3
    }
  },
  checked: {},
  track: {}
});

const PrivateSwitch = ({
  isPrivate,
  onChange,
  ...props
}) => {
  const description = isPrivate ? `This can't be undone. Once you've made a channel private, it can't be changed back.` : 'When a channel is set to private, it can only be viewed or joined by invitation.';

  return (
    <section className='flex-rows' style={{ padding: '16px 0', alignItems: 'center' }}>
      <div className='flex-columns flex-1'>
        <Typography type='bold' style={{ fontSize: '0.875rem' }}>Make Private</Typography>
        <Typography>{description}</Typography>
      </div>
      <Switch
        classes={props.classes}
        value={isPrivate}
        onChange={event => onChange(event.target.checked)}
      />
    </section>
  );
};

PrivateSwitch.propTypes = {
  isPrivate: PropTypes.bool,
  onChange: PropTypes.func
};

export default withStyles(styles)(PrivateSwitch);
